import styled, { css } from 'styled-components';

export const ConteudoPlataforma = styled.section`
  > h3 {
    margin-bottom: calc(30px / 2);
    text-align: center;
  }
  > p {
    margin: 0 auto;
    max-width: 650px;
    text-align: center;
    width: 90%;
  }
  &:nth-child(even) {
    > div {
      flex-direction: row-reverse;
      ${({ theme }) => {
        return (
          theme &&
          css`
            @media (max-width: ${theme.breakpoints.medium}) {
              flex-direction: column;
            }
          `
        );
      }}
    }
  }
  > div {
    align-items: center;
    display: flex;
    justify-content: space-between;
    ${({ theme }) => {
      return (
        theme &&
        css`
          @media (max-width: ${theme.breakpoints.medium}) {
            flex-direction: column;
          }
        `
      );
    }}
  }
`;

export const Container = styled.div`
  align-items: center;
  box-sizing: border-box;
  justify-content: space-between;
  margin: 0 auto;
  max-width: 1440px;
  padding: 0 80px;
  ${({ theme }) => {
    return (
      theme &&
      css`
        @media (max-width: ${theme.breakpoints.medium}) {
          padding: 0 16px;
          flex-direction: column;
        }
      `
    );
  }}
`;

export const Text = styled.div`
  width: 45%;
  ${({ theme }) => {
    return (
      theme &&
      css`
        @media (max-width: ${theme.breakpoints.medium}) {
          width: 100%;
        }
      `
    );
  }}
  h3,
  h4 {
    margin: calc(30px / 2) 0px;
  }
  p {
  }
  strong {
    color: #364ef7;
  }
`;

export const Image = styled.div`
  align-items: center;
  display: flex;
  height: 0;
  justify-content: center;
  padding-bottom: calc(39% - 90px);
  position: relative;
  width: calc(47% - (30px * 3));
  > div {
    position: static !important;
  }
  ${({ theme }) => {
    return (
      theme &&
      css`
        @media (max-width: ${theme.breakpoints.medium}) {
          width: 100%;
          padding-bottom: calc(100% - 90px);
        }
      `
    );
  }}
  .img {
    background: white;
    border-top: 5px solid #364ef7 !important;
    bottom: auto !important;
    height: 80% !important;
    left: 50% !important;
    min-height: auto !important;
    min-width: auto !important;
    position: absolute;
    right: auto !important;
    top: 50% !important;
    transform: translate(-50%, -50%);
    width: 95% !important;
  }
  .icon {
    fill: #364ef7;
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
    z-index: -9;
  }
`;
